import { KeyboardEvent } from "react";
import { capitalize, markMatch, Tooltip } from "@datassential/platform-ui-lib";
import { IMacListItem } from "@models/MacListItem";
import { MacExportFormat } from "@apiHooks/useMacExport";
import { MAC_EXPORT_OPTIONS } from "../MacsList/MacsList.constants";

interface MacsListRowTooltipsProps {
    item: IMacListItem;
    index: number;
    query: string;
    onExport: (format: MacExportFormat) => void;
}

const THUMBNAIL_TOOLTIP_STYLE = { fontSize: 0, lineHeight: 0 };
const DESCRIPTION_TOOLTIP_STYLE = { maxWidth: 400, zIndex: 1000 };

const MacsListRowTooltips = ({ item, index, query, onExport }: MacsListRowTooltipsProps) => {
    const trimmedQuery = query.trim();
    const additionalHtml = trimmedQuery === ''
        ? item.description.additional
        : markMatch(item.description.additional, trimmedQuery, true);

    const handleKeyDown = (format: MacExportFormat) => (e: KeyboardEvent) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        onExport(format);
    };

    return (
        <>
            <Tooltip
                id={`macs-list-table-item-thumbnail-${item.id}`}
                place="right"
                style={THUMBNAIL_TOOLTIP_STYLE}
                delayShow={200}
            >
                <div
                    className="MacsListTable__thumbnail"
                    data-testid={`buttonMacsThumbnail-${index}`}
                >
                    <img src={item.thumbnailUrl} alt="thumbnail"/>
                </div>
            </Tooltip>
            <Tooltip
                id={`macs-list-table-item-description-${item.id}`}
                place="right"
                style={DESCRIPTION_TOOLTIP_STYLE}
            >
                <div
                    className="MacsListTable__description-tooltip"
                    dangerouslySetInnerHTML={{ __html: additionalHtml }}
                />
            </Tooltip>
            <Tooltip
                id={`macs-list-table-item-download-${item.id}`}
                place="left"
                clickable
            >
                <div className="MacsListTable__download-links">
                    {MAC_EXPORT_OPTIONS.map(({ label, format }) => (
                        <div
                            key={format}
                            role="button"
                            tabIndex={0}
                            onClick={() => onExport(format)}
                            onKeyDown={handleKeyDown(format)}
                            className="MacsListTable__download-link"
                            data-testid={`buttonMacsDownloadLink${capitalize(label)}-${index}`}
                        >
                            {label}
                        </div>
                    ))}
                </div>
            </Tooltip>
        </>
    );
};

export default MacsListRowTooltips;
